import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./ProductCard.css";
import {
  AiOutlineHeart,
  AiOutlineShoppingCart,
  AiOutlineEye,
} from "react-icons/ai";
import { RiStarHalfSLine } from "react-icons/ri";
import { addToCart } from "../../containers/rtk/slices/slice";
import { Link } from "react-router-dom";
// import { AiOutlineSta } from "react-icons/ai";
const ProductCard = (props) => {
  const dispatch = useDispatch();
  // start loader
  const [loader, showloader] = useState(false);
  const showloaderr = () => {
    showloader(true);
    setTimeout(() => {
      showloader(false);
    }, 1200);
    window.scrollTo(0, 0);
  };
  return (
    <>
      {loader && (
        <div className="mainloader">
          <span className="Circleloader"></span>
        </div>
      )}
      <div className="productcard">
        <span style={{ float: "right", fontSize: "19px" }}>
          <AiOutlineHeart />
        </span>
        <div className="product_icons">
          <AiOutlineShoppingCart
            onClick={() => dispatch(addToCart(props.productdetails))}
          />
          <Link to={`/ProductDetails/${props.productdetails.id}`}>
            <AiOutlineEye />
          </Link>
        </div>
        <div className="product_img">
          <img
            src={props.productimg}
            alt="productimg"
            style={{ width: "100%" }}
          ></img>
        </div>
        <div className="product_details">
          <Link
            to={`/ProductDetails/${props.productdetails.id}`}
            onClick={() => showloaderr()}
          >
            {props.name}
          </Link>
          <a href="productpage">{props.discount}</a>
          <span>
            {/* <AiOutlineSta />
            <AiOutlineSta />
          <AiOutlineSta /> */}
            <RiStarHalfSLine />
            <RiStarHalfSLine />
            <RiStarHalfSLine />
            <RiStarHalfSLine />
          </span>
          <small>${props.price.slice(0, 2)}</small>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
